const ADMIN = {
  UPDATE_FIELD_VALUE: 'ADMIN_UPDATE_FIELD_VALUE',
  UPDATE_ERROR: 'UPDATE_ERROR',
  DISPLAY_TOAST: 'DISPLAY_TOAST',
  RESET_VALUES: 'RESET_VALUES',
  VERIFY_EMAIL: 'VERIFY_EMAIL',
  VERIFY_EMAIL_SUCCESS: 'VERIFY_EMAIL_SUCCESS',
  VERIFY_EMAIL_FAILURE: 'VERIFY_EMAIL_FAILURE',
  ADD_USER: 'ADD_USER',
  ADD_TEAM_MEMBER: 'ADD_TEAM_MEMBER',
  ADD_USER_SUCCESS: 'ADD_USER_SUCCESS',
  UPDATE_USER: 'UPDATE_USER',
  UPDATE_USER_SUCCESS: 'UPDATE_USER_SUCCESS',
  GET_USER_DETAILS: 'GET_USER_DETAILS',
  GET_USER_DETAILS_SUCCESS: 'GET_USER_DETAILS_SUCCESS',
  GET_USER_DETAILS_FAILURE: 'GET_USER_DETAILS_FAILURE',
  IS_SINGLE_ACCOUNT: 'IS_SINGLE_ACCOUNT',
  PROGRESS_ON: 'PROGRESS_ON',
  PROGRESS_OFF: 'PROGRESS_OFF',
  GET_LANGUAGE_DETAILS: 'GET_LANGUAGE_DETAILS',
  GET_LANGUAGE_DETAILS_SUCCESS: 'GET_LANGUAGE_DETAILS_SUCCESS',
  GET_LANGUAGE_DETAILS_FAILURE: 'GET_LANGUAGE_DETAILS_FAILURE',
  FETCH_REGEX_REQUEST: 'FETCH_REGEX_REQUEST',
  FETCH_REGEX_SUCCESS: 'FETCH_REGEX_SUCCESS',
  FETCH_REGEX_FAILURE: 'FETCH_REGEX_FAILURE'
}

export { ADMIN };